import React from 'react';
import cx from 'classnames';
import DropDownMenu from './dropDownMenu';
import NaviBarStore from './store';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import LanguageSelect from '../common-language-select';
import FollowUs from '@src/business-components/common-follow-us';
import { $$tracker } from '@src/tracker';
// import getPageLocalesData from '@src/global-locales/get-page-locales-data';

const styles = require('./index.less');
// const styles = require('./rem.less');

/**s
 * NaviBar
 * @param className
 * @param store {NaviBarStore}
 * @returns {JSX.Element}
 * @constructor
 */
const NaviBar = ({ className, store }) => {
  store.use();
  const { dropDownMenuStore, $globalStore } = store;
  // const pageLocalesData = getPageLocalesData();

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 200 }}>
      <div className={cx(styles.navRoot, className, store.isSticky && styles.sticky)}>
        <DropDownMenu store={dropDownMenuStore} isSticky={store.isSticky} />
        <div className={cx(styles.navbarMain, !dropDownMenuStore.isExpand && styles.active)}>
          <div className={styles.nbLeftGroup} onMouseOver={() => dropDownMenuStore.onLogoMenuHover()}>
            <img className={styles.seasunLogo} alt="西山居" src={require('./images/normal-seasun-logo.png')} />
            <div className={styles.dropDownIcon} />
          </div>
          <div className={styles.nbRightGroup}>
            <div className={styles.groupLeft}>
              <Link className={styles.logo} href={store.officialLink} target="_blank" />
              <div className={styles.navList}>
                {store.navList.map((item, index) => {
                  return (
                    <div className={cx(styles.navBtn, store.currentIndex === index && styles.active)} key={index}>
                      <div className={styles.navTitle} onClick={() => store.clickMenu(index, item)}>
                        {item.title}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={styles.groupRight}>
              <div className={styles.followUs}>
                <FollowUs store={store.followUsStore} />
              </div>
              <div className={styles.changeLanguageBtn}>
                <LanguageSelect store={store.selectStore} buttonDisplay={'nav'} />
              </div>
              <Link className={styles.btnToOfficial} href={store.officialLink} onClick={() => $$tracker.clickMainNaviBarOfficialSite()} target="_blank" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default wrapStore(NaviBar, NaviBarStore);
